import { Pagination } from 'projects/access-control/src/app/Domain/Entities/pagination.interface';
import { IRole } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';
import { UsersGroups } from 'projects/access-control/src/app/Domain/Entities/userGroups.interface';
import { DataPagination } from '../../../Domain/Adapters';

export const USERS_STATE_NAME = 'Users';

export interface UsersState {
	users: UsersGroups[];
	pagination: DataPagination;
  paginationInit:Pagination;
  loading: boolean;
}

export const initialStateUsers: UsersState = {
	users: [],
	pagination: {} as DataPagination,
  paginationInit: {} as Pagination,
	loading: false
};
